export default "__VITE_ASSET__GP6NSHpZ__"